import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import BootstrapVue from "bootstrap-vue"
// import Vuex from 'vuex'





Vue.use(BootstrapVue);

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import VAnimateCss from 'v-animate-css';
Vue.use(VAnimateCss);

// import VeeValidate from 'vee-validate';
// Vue.use(VeeValidate);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)



import VueFire from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
Vue.use(VueFire)
firebase.initializeApp({
    apiKey: "AIzaSyD7ZoO21XS3xx55Viijg-_h9dQF-RByoeY",
    authDomain: "surveyjs-136a0.firebaseapp.com",
    databaseURL: "https://surveyjs-136a0.firebaseio.com",
    projectId: "surveyjs-136a0",
    storageBucket: "surveyjs-136a0.appspot.com",
    messagingSenderId: "541329252490"
})
const firestore = firebase.firestore()
const settings = { timestampsInSnapshots: true };
firestore.settings(settings)
export const db = firebase.firestore()


//global registration
// import VueFormWizard from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// Vue.use(VueFormWizard)

Vue.config.productionTip = false

Vue.prototype.$http = require('axios');


new Vue({
  router,
  store,
  i18n,
  data: {
    name: ''
  },
  // computed: {
  //   getStoredCreatedAt() {
  //     return this.$store.state.answers.createdAt
  //   },
  //   // ...Vuex.mapState(['answers'])
  // },
  // created: function () {

  //   if (this.getStoredCreatedAt == undefined) {
  //     this.$store.state.answers.createdAt = firebase.firestore.FieldValue.serverTimestamp()
  //   }
  // },


  render: h => h(App)
}).$mount('#app')
